export class AssociatePasswordWithVaultEntry {
    passwordId: number;
    encryptedPasswordKey: string;
}